const section_1 = document.getElementById("section-1"), go_down = document.getElementById("go-down"), scroll_up = document.getElementById("scroll-up");
export const buttonGoDown = () => {
    go_down === null || go_down === void 0 ? void 0 : go_down.addEventListener("click", () => {
        !!section_1 && window.scrollTo(0, section_1.getBoundingClientRect().top);
    });
};
export const buttonGoUp = () => {
    scroll_up.addEventListener("click", () => {
        window.scrollTo(0, 0);
    });
};
